import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withKeys as _withKeys, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "paloma-modal-wrapper" };
const _hoisted_2 = { class: "modal__header" };
const _hoisted_3 = { class: "modal__content" };
import Icon from "./Icon.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Modal',
    props: {
        classes: {},
        unclosable: { type: Boolean }
    },
    emits: [
        'close'
    ],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        function close() {
            !props.unclosable && emit('close');
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                _createVNode(_Transition, { name: "modal" }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", {
                            class: "paloma-modal-backdrop",
                            onKeyup: _withKeys(close, ["esc"])
                        }, [
                            _createElementVNode("div", _hoisted_1, [
                                _createElementVNode("div", {
                                    class: _normalizeClass(["modal", __props.classes])
                                }, [
                                    (!__props.unclosable)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 0,
                                            onClick: _withModifiers(close, ["prevent"]),
                                            href: "",
                                            class: "modal__close"
                                        }, [
                                            _createVNode(Icon, {
                                                name: "times",
                                                "icon-style": "light"
                                            })
                                        ]))
                                        : _createCommentVNode("", true),
                                    _cache[2] || (_cache[2] = _createTextVNode()),
                                    _renderSlot(_ctx.$slots, "body", {}, () => [
                                        _createElementVNode("header", _hoisted_2, [
                                            _renderSlot(_ctx.$slots, "header")
                                        ]),
                                        _cache[0] || (_cache[0] = _createTextVNode()),
                                        _createElementVNode("section", _hoisted_3, [
                                            _renderSlot(_ctx.$slots, "content")
                                        ]),
                                        _cache[1] || (_cache[1] = _createTextVNode()),
                                        _renderSlot(_ctx.$slots, "footer")
                                    ])
                                ], 2)
                            ])
                        ], 32)
                    ]),
                    _: 3
                })
            ]));
        };
    }
});
